import { Controller } from 'stimulus';

class CoursesFilterController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    import('../courses-filter').then((mod) => {
      mod.default({
        element: this.element,
        search: this.searchTarget,
        datepicker: this.dateTarget,
        multipleSelects: this.multipleSelectTargets,
        singleSelects: this.singleSelectTargets,
        output: this.outputTarget,
        total: this.totalTarget,
        emptyState: this.emptyStateTarget,
        errorState: this.errorStateTarget,
        sort: this.sortTarget,
      }, {
        api: this.data.get('api'),
      });
    });

    this.onChangeSort();
  }

  onChangeSort() {
    const selectedOption = this.sortTarget.options[this.sortTarget.selectedIndex];
    const selectedOptionText = selectedOption.innerText.trim();

    // Create a fake element holding the text to check its width
    const fakeEl = document.createElement('span');
    fakeEl.style.visibility = 'hidden';
    fakeEl.style.position = 'absolute';
    fakeEl.style.whiteSpace = 'nowrap';
    fakeEl.textContent = selectedOptionText;

    document.body.appendChild(fakeEl);

    const arrowWidth = 25;

    this.sortTarget.style.width = `${fakeEl.offsetWidth + arrowWidth}px`;

    fakeEl.remove();

    this.sortTarget.classList[this.sortTarget.value ? 'add' : 'remove']('is-changed');
  }
}

CoursesFilterController.targets = [
  'search',
  'date',
  'singleSelect',
  'multipleSelect',
  'output',
  'total',
  'emptyState',
  'errorState',
  'sort',
];

export default CoursesFilterController;
